import {Component} from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  imports: [
    RouterLink
  ],
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {

  constructor() {
  }

}
